import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ProfilePasswordFormComponent } from 'shared/profile/profile-password-form/profile-password-form.component';

// uncomment when add methods
// import { ProfileInfoService } from 'shared/profile/profile-info.service';


/**
 *    This class represents the lazy loaded WelcomeComponent.
 */

@Component({
  moduleId: module.id,
  selector: 'welcome-cmp',
  templateUrl: 'welcome.component.html',
  styleUrls: ['welcome.component.scss'],
  // providers: [ProfileInfoService],
})
export class WelcomeComponent {

  @ViewChild('profileForm', {static: false}) profileForm: ProfilePasswordFormComponent | void;
  isCompleted: boolean = false;

  constructor(
    // private profileInfoService: ProfileInfoService,
    protected router: Router,
  ) {}

  // getters
  get form() {
    return this.profileForm ? this.profileForm.form : null;
  }

  // handlers
  onCompleteRegistrationClick() {
    if (!this.form || this.form.invalid) { return; }
    const value = this.form.value;
    console.log(`Complete registration with password: ${value.newPassword}`);
    this.isCompleted = true;
  }

  onLoginClick() {
    this.router.navigate(['/login']);
  }
}
